// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"7accd00e","220":"3413b103","271":"5504611c","870":"9bddcecc"}[chunkId] + ".chunk.js";
};